var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffa700;}.cls-2{fill:none;stroke:#ffa700;stroke-miterlimit:10;stroke-width:2.6px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.18374,1.63907l2.045,5.08024a.48432.48432,0,0,0,.47358.34442l4.908-.04305a.50059.50059,0,0,1,.30137.90411L13.77866,11.0246a.47091.47091,0,0,0-.17222.55968L15.09177,16.643a.50337.50337,0,0,1-.775.55969l-4.30529-2.94913a.48438.48438,0,0,0-.58122,0L5.125,17.20269a.50259.50259,0,0,1-.775-.55969L5.8354,11.60581a.50132.50132,0,0,0-.17221-.55969L1.53011,7.92479a.50059.50059,0,0,1,.30137-.90411l4.908.04305a.48432.48432,0,0,0,.47358-.34442l2.045-5.08024A.48538.48538,0,0,1,10.18374,1.63907Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.18374,1.63907l2.045,5.08024a.48432.48432,0,0,0,.47358.34442l4.908-.04305a.50059.50059,0,0,1,.30137.90411L13.77866,11.0246a.47091.47091,0,0,0-.17222.55968L15.09177,16.643a.50337.50337,0,0,1-.775.55969l-4.30529-2.94913a.48438.48438,0,0,0-.58122,0L5.125,17.20269a.50259.50259,0,0,1-.775-.55969L5.8354,11.60581a.50132.50132,0,0,0-.17221-.55969L1.53011,7.92479a.50059.50059,0,0,1,.30137-.90411l4.908.04305a.48432.48432,0,0,0,.47358-.34442l2.045-5.08024A.48538.48538,0,0,1,10.18374,1.63907Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStar);
export default __webpack_public_path__ + "static/media/ic_star.94324ce707a5b5c2124ced68efd6a677.svg";
export { ForwardRef as ReactComponent };